var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('PDFViewer',{staticStyle:{"height":"100vh","width":"100vw"},attrs:{"source":_vm.src,"controls":_vm.controls}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }